import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO_REQUEST__tokens_add } from '@shared/common/_requests/DTO_REQUEST__tokens_add';
import { try_add_token_to_array_of_tokens_with_word_english } from '@shared/dto/generation/settings/token/_methods/try_add_token_to_array_of_tokens_with_word_english';
import { DTO__token } from '@shared/dto/generation/settings/token/DTO__token';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { update_search_locally } from '../_methods/update_search_locally';
import { StateSearch } from '../state_search';

export const remote_search_token_add = createAsyncThunkSafe<void, DTO_REQUEST__tokens_add>(
  ENUM__network_event_client_to_server.SEARCH_TOKEN_ADD,
  async (request): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.SEARCH_TOKEN_ADD, request);
  },
);

export function init_remote_search_token_add(builder: ActionReducerMapBuilder<StateSearch>) {
  builder
    .addCase(remote_search_token_add.pending, (state, action) => {
      let request = action.meta.arg;

      let search_id = request.entity_id;

      let search = state.search_history_map.get_or_assert(search_id, { context: 'search' });

      let tokens_new = [...search.tokens];

      for (let token_create_data of request.tokens_data) {
        //show as english word. all settings will be replaced by server update
        tokens_new = try_add_token_to_array_of_tokens_with_word_english(
          search.tokens,
          token_create_data.word_with_context.word,
          token_create_data.is_positive,
          true,
        );
      }

      tokens_new = tokens_new.sort(DTO__token.sortByWordTranslated);

      search = search.clone({ tokens: tokens_new });

      update_search_locally(state, search);
    })
    .addCase(remote_search_token_add.rejected, (state, action) => {})
    .addCase(remote_search_token_add.fulfilled, (state, action: PayloadAction) => {});
}
